import { useEffect, useMemo, useState } from "react";

import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useClusterV2 = ({ clustersDisponiveis }) => {
  const [clusters, setClusters] = useState([]);

  useEffect(() => {
    const fetchClusters = async (signal) => {
      let query = db.cluster;

      if (clustersDisponiveis) {
        query = query.where("id").anyOf(clustersDisponiveis);
      }

      const clustersResult = [];
      await query.each((cluster) => clustersResult.push(cluster));

      if (!signal.aborted) {
        setClusters(clustersResult);
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchClusters(signal);

    return () => {
      controller.abort();
    };
  }, [clustersDisponiveis]);

  const searchClusterById = (id) => {
    return db.cluster.get(id);
  };

  const optionClusters = useMemo(
    () =>
      prepareForOptions(
        (clusters || []).sort((a, b) => a.nome.localeCompare(b.nome)),
        ["nome"],
        "id"
      ),
    [clusters]
  );

  return {
    searchClusterById,
    clusters,
    optionClusters,
  };
};

export default useClusterV2;
